// furiganaAria.js — reading aid for ATTRIBUTE surfaces that cannot host <ruby>.
//
// title / placeholder / <optgroup label> are plain-text attributes: a sighted
// furigana-user can SEE them (a hover tooltip, an empty field's placeholder, a
// dropdown group heading) but they cannot carry <ruby>. So instead of ruby we
// append the hiragana reading in parentheses after each kanji run:
//   "削除"        → "削除（さくじょ）"
//   "割合と傾向"  → "割合（わりあい）と傾向（けいこう）"
// Consecutive kanji (a word, or a per-kanji-fallback run) are merged into ONE
// parenthetical so it reads cleanly. Text with no covered kanji is unchanged.
//
// NOTE (deliberate): aria-label is intentionally NOT processed by this helper.
// Screen readers pronounce kanji from their own dictionaries, so appending a
// parenthetical reading makes them announce it twice; the sighted furigana-user is
// served by the visible, ruby-wrapped control the aria-label mirrors. Use this only
// for the VISIBLE attribute surfaces above.
import { annotateFurigana } from './furigana';

export function furiganaAria(text, dicts) {
  if (typeof text !== 'string' || text.length === 0) return text;
  const segs = annotateFurigana(text, dicts);
  if (!segs.some((s) => s.reading)) return text; // nothing covered → unchanged

  let out = '';
  let baseBuf = '';
  let readBuf = '';
  const flush = () => {
    if (baseBuf) {
      out += `${baseBuf}（${readBuf}）`;
      baseBuf = '';
      readBuf = '';
    }
  };
  for (const s of segs) {
    if (s.reading) {
      baseBuf += s.base;
      readBuf += s.reading;
    } else {
      flush();
      out += s.text;
    }
  }
  flush();
  return out;
}
